module.exports = __webpack_public_path__ + "static/media/gift_1.e0916973.png";